import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";
import { Cell } from "react-md";
import RCTContainer from "components/QualityAssurance/Sections/Calc/RCTContainer";

const Calc = (props) => {
    const { controlNumber, caseRCT } = props;

    if (Object.keys(caseRCT).length) {
        return (
            <Cell size={12} className="width-unset flex-child flex-parent flex-column">
                <RCTContainer caseRCT={caseRCT} controlNumber={controlNumber} />
            </Cell>
        );
    } else return null;
};

Calc.propTypes = {
    // passed props
    controlNumber: PropTypes.number.isRequired,

    // redux props
    caseRCT: PropTypes.object,
};

const mstp = state => {
    return {
        caseRCT: state.qualityAssurance.caseRCT,
    };
};

export default connect(mstp)(Calc);